import React from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import FieldErrorMessage from '../FieldErrorMessage';

const Textarea = (props) => {
  const { label, name, placeholder, isRequired, rules } = props;
  const { register } = useFormContext();
  return (
    <div className={`form-item form-item--textarea`}>
      {label && <label htmlFor={name}>{label}</label>}
      <textarea name={name} placeholder={placeholder} required={isRequired} ref={register(rules)} />
      <FieldErrorMessage name={name} />
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  rules: PropTypes.objectOf(PropTypes.any),
};

Textarea.defaultProps = {
  label: '',
  rules: null,
};

export default Textarea;
